
  import { WINNERS } from '@/constants/awards';

  export default {
    computed: {
      awards () {
        const provider = this.$store.getters['providers/get'];
        if (provider) {
          return WINNERS[provider.slug];
        }
        return null;
      }
    }
  };
